"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrictModeSanitizer = void 0;
const StrictModeSanitizer = (value) => {
    if (value === 'null') {
        return null;
    }
    return value === 'true' || value === '1';
};
exports.StrictModeSanitizer = StrictModeSanitizer;
